// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "dde57e891dfb1a2d3ac9ecebe0c44690" + ".js";
};